<template>
    <!-- 전체 콘텐츠 영역 -->
    <div class="main-contents gray-back">
        <div class="news_wrap">
          <div class="path">커뮤니티</div>
          <div class="news-center-wrap">
            <div class="news-box">
              <div class="news-box-title">공지사항</div>
              <ul class="news-box-list">
              <li v-for="(noti) in noticeList" :key="noti.newsCenterSeq"><a @click="goNotice(noti.newsCenterSeq)"><span v-if="noti.newNews=='Y'" class="new">N</span>{{noti.newsCenterTitle}}</a></li>
              </ul>
              <a @click="pageMove('BBS002M01')" class="link-more">+ 더보기</a>
            </div>
            <div class="news-box">
              <div class="news-box-title">그레이트프로 뉴스</div>
              <ul class="news-box-list">
                <li v-for="(news) in newsList" :key="news.newsCenterSeq"><a @click="goNews(news.newsCenterSeq)"><span v-if="news.newNews=='Y'" class="new">N</span>{{news.newsCenterTitle}}</a></li>
              </ul>
              <a @click="pageMove('BBS003M01')" class="link-more">+ 더보기</a>
            </div>
          </div>
        </div>
      </div>
</template>

<script>
import { communityMeta } from '@/utils/meta';

export default {
  metaInfo : communityMeta,

    data() {
        return {
            noticeList : [],
            newsList: [],
        }
    },
    mounted() {
      this.getNewsCenterList();
    },
    methods: {
        getNewsCenterList() {
            // seq, title, reg
            this.$.httpPost('/api/main/bbs/getNewsCenterList')
                .then(res => {
                    this.noticeList = res.data.noticeList;
                    this.newsList = res.data.newsList;
                }).catch(this.$.httpErrorCommon);
        },

        goNotice(idx) {
            this.$router.push({name: 'BBS002M02', query:{no : idx}});
        },

        goNews(idx) {
            this.$router.push({name: 'BBS003M02', query:{no : idx}});
        },

        pageMove(name) {
          //console.log('name', name);
          this.$router.move(name);
		  },

      
    },

}
</script>